import { resolveIcon } from './icons/resolveIcon.mjs';
export default {
  name: 'SvgIcon',
  props: {
    name: {
      type: String,
      required: true
    },
    viewBox: {
      type: String,
      default: '0 0 24 24'
    },
    size: {
      type: [String, Number],
      default: '18px'
    },
    variant: {
      type: String,
      default: 'white'
    },
    isFillIcon: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      iconComponent: () => {},
      iconMaskId: `bee-icon-${this._uid}`
    };
  },
  computed: {
    standardIcon() {
      return resolveIcon(this.name);
    }
  },
  watch: {
    name: {
      immediate: true,
      handler() {
        if (!resolveIcon(this.name)) {
          this.iconComponent = () => import(`@/assets/icons/${this.name}.svg`);
        }
      }
    }
  }
};